<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}" @click="goWebsite">
    {{ platformInfo }}
    <transition name="sidebarLogoFade">
      <div v-if="collapse" key="collapse" class="sidebar-logo-link">
        <img v-if="logo" :src="logo" class="sidebar-logo">
      </div>
      <div v-else key="expand" class="sidebar-logo-link">
        <img v-if="logo" :src="logo" class="sidebar-logo">
        <h1 class="sidebar-title">{{ title }} </h1>
      </div>
    </transition>
  </div>
</template>

<script>

import { getToken } from '@/utils/auth';
import { mapGetters } from 'vuex'

export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title: '',
      logo: '',
      websiteUrl: ''
    }
  },
  computed: {
    ...mapGetters(['platformInfo'])
  },
  watch: {
    platformInfo: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.logo = newVal.logoUrl
          this.title = newVal.platformName
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
    goWebsite() {
      if (this.websiteUrl) {
        window.open(`//${this.websiteUrl}/login?tk=${getToken()}`, '_blank')
      }
      else {
        this.$router.push('/')
      }
    }
  },
}

</script>

<style lang="scss" scoped>
  .sidebarLogoFade-enter-active {
    transition: opacity 1.5s;
  }

  .sidebarLogoFade-enter,
  .sidebarLogoFade-leave-to {
    opacity: 0;
  }

  .sidebar-logo-container {
    position: relative;
    width: 100%;
    height: 80px;
    text-align: center;
    overflow: hidden;

    & .sidebar-logo-link {
      height: 100%;
      width: 100%;
      display: flex !important;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      & .sidebar-logo {
        width: 100px;
        vertical-align: middle;
        margin-right: 6px;
      }

      & .sidebar-title {
        display: inline-block;
        margin: 0;
        // color: #fff;
        font-weight: 600;
        line-height: 30px;
        font-size: 16px;
        font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
        vertical-align: middle;
      }
    }

    &.collapse {
      .sidebar-logo {
        margin-right: 0px;
        transform: scale(1.2);
      }
    }
  }

</style>
